"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLogger = void 0;
const createLogger = (logger, actionId) => {
    return {
        fail(reason) {
            logger.warn(`A feature app cannot be opened in a layer by user interaction ${actionId} because ${reason}`);
        },
        warn(reason) {
            logger.warn(`Parameter warning by user interaction ${actionId}: ${reason}`);
        },
    };
};
exports.createLogger = createLogger;
//# sourceMappingURL=createLogger.js.map